import React, { FC } from 'react';

import { Badge } from 'evergreen-ui';
import { CoverageTier } from '../models/enums';

export const CoverageTierBadge: FC<{ coverageTier?: CoverageTier }> = ({ coverageTier }) => {
  switch (coverageTier) {
    case CoverageTier.EMPLOYEE:
      return <Badge color="blue">Employee</Badge>;
    case CoverageTier.EMPLOYEE_SPOUSE:
      return <Badge color="teal">Employee + Spouse</Badge>;
    case CoverageTier.EMPLOYEE_CHILDREN:
      return <Badge color="orange">Employee + Children</Badge>;
    case CoverageTier.FAMILY:
      return <Badge color="purple">Family</Badge>;
    default:
      return <></>;
  }
};
